import createErrorType from 'app/utils/createErrorType';

interface IArgs {
  id: string | undefined;
  token: string | undefined;
}

export class ImpossibleJoinError extends createErrorType('ImpossibleJoinError') {
  public id: string | undefined;
  public token: string | undefined;

  public static build({ id, token }: IArgs) {
    let message;

    if (!id && !token) {
      message = 'Both room id and token are missing';
    } else if (!id) {
      message = 'Missing room id';
    } else {
      message = 'Missing room token';
    }

    return new ImpossibleJoinError({
      id, token, message,
    });
  }

  private constructor(args: IArgs & { message: string }) {
    super(args.message);

    this.id = args.id;
    this.token = args.token;
  }
}
